module.exports = __webpack_public_path__ + "static/img/patho-inflammation-low-CBVQhxZF.e030957f.png";